import styled from 'styled-components';
import badge from '../../assets/svg/billQuantityBadge.svg';

const BillQuantityBadge = styled.div`
    background: url(${badge});
    background-repeat: no-repeat;
    background-size: cover;
    width: 30px;
    height: 40px;
`;

export const BillsCount = styled.span`
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    display: flex;
    justify-content: center;
    ${({ theme }) => `
        color: ${theme.palette.common.white};
    `}
`;

export const BillsLabel = styled(BillsCount)`
    font-size: 12px;
    line-height: 12px;
`;

export default BillQuantityBadge;
